import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button, Stack, TextField, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import AuthCard from "./AuthCard";
import { forgotPassword } from "../../shared/api";
import { validateForgotPasswordForm } from "./helpers";

function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [errorKey, setErrorKey] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorKey("");
    setIsSuccess(false);

    const validationErrorKey = validateForgotPasswordForm({ email });
    if (validationErrorKey) {
      setErrorKey(validationErrorKey);
      return;
    }

    setIsSubmitting(true);
    try {
      await forgotPassword({ email });
      setIsSuccess(true);
      setEmail("");
    } catch {
      // Keep anti-enumeration UX: always show generic success state.
      setIsSuccess(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthCard
      title={t("auth.forgotPasswordTitle")}
      subtitle={t("auth.forgotPasswordDescription")}
    >
      <Stack component="form" spacing={2} onSubmit={handleSubmit}>
        <TextField
          required
          type="email"
          label={t("auth.emailLabel")}
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />

        {errorKey ? <Typography color="error">{t(errorKey)}</Typography> : null}

        {isSuccess ? (
          <Alert severity="success">{t("auth.forgotPasswordSuccess")}</Alert>
        ) : null}

        <Button type="submit" variant="contained" disabled={isSubmitting}>
          {isSubmitting
            ? t("common.loading")
            : t("auth.requestResetLinkButton")}
        </Button>
        <Button component={RouterLink} to="/sign-in">
          {t("auth.goToSignIn")}
        </Button>
      </Stack>
    </AuthCard>
  );
}

export default ForgotPasswordPage;
